export default "__VITE_PUBLIC_ASSET__1dd95e81__"